import { Component, OnInit, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/_services/auth.service';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { environment } from 'src/environments/environment';
import { appConfig } from 'src/app/_core/config/app-config.const';

@Component({
  selector: 'tangram-draft-tangrams',
  templateUrl: './draft-tangrams.component.html',
  styleUrls: ['./draft-tangrams.component.scss'],
})
export class DraftTangramsComponent implements OnInit, OnDestroy {
  @ViewChild('AlertContent', { static: true }) alertContent!: TemplateRef<any>;

  imgPath = appConfig.imagePath;
  iconPath = appConfig.iconPath;
  placeholderImage = 'assets/img/videos/img6.png';

  drafts: any[] = [];
  isLoading = true;
  currentPathwayId = '';
  alterMessage = '';
  pendingAction: 'delete' | 'publish' | null = null;
  currentUser: any;

  constructor(
    private dashboardService: DashboardService,
    private router: Router,
    private modalService: NgbModal,
    private toaster: ToastrService,
    private authService: AuthService,
  ) {
    this.currentUser = this.authService.currentUserValue;
  }

  ngOnInit() {
    this.loadDrafts();
  }

  ngOnDestroy() {}

  loadDrafts() {
    this.isLoading = true;
    this.dashboardService.getMyDraftsList().subscribe(
      (response: any) => {
        this.isLoading = false;
        const list = (response && response.data) ? response.data : [];
        this.drafts = list.map((d: any) => {
          let overviewImageUrl = this.placeholderImage;
          if (d.imageURL) {
            overviewImageUrl = `${environment.backendUrl}${d.imageURL}`;
          } else if (d.tempImageURL) {
            overviewImageUrl = d.tempImageURL;
          }
          return { ...d, overviewImageUrl };
        });
      },
      (err: any) => {
        this.isLoading = false;
        this.toaster.error((err && err.error && err.error.message) || 'Failed to load drafts.');
      },
    );
  }

  openDraft(draft: any) {
    this.router.navigate(['/edit-tangram', draft._id]);
  }

  previewDraft(draft: any) {
    this.router.navigate(['/dashboard', draft._id]);
  }

  createTangram() {
    this.router.navigate(['/create-tangram']);
  }

  updateOverviewImageUrl(_event: Event, i: number) {
    if (this.drafts[i]) {
      this.drafts[i].overviewImageUrl = this.placeholderImage;
    }
  }

  confirmDelete(pathwayId: string) {
    this.currentPathwayId = pathwayId;
    this.pendingAction = 'delete';
    this.alterMessage = 'Delete this draft? This cannot be undone.';
    this.modalService.open(this.alertContent, { centered: true, windowClass: 'unlock-premium' });
  }

  confirmPublish(pathwayId: string) {
    this.currentPathwayId = pathwayId;
    this.pendingAction = 'publish';
    this.alterMessage = 'Publish this draft? It will move out of drafts into your Tangrams.';
    this.modalService.open(this.alertContent, { centered: true, windowClass: 'unlock-premium' });
  }

  onAlertConfirmed() {
    if (this.pendingAction === 'delete') {
      this.deleteDraft();
    } else if (this.pendingAction === 'publish') {
      this.publishDraft();
    }
  }

  private deleteDraft() {
    const pathwayId = this.currentPathwayId;
    this.dashboardService.deleteTangram({ pathwayId }).subscribe(
      (res: any) => {
        if (res && res.success) {
          this.drafts = this.drafts.filter((t) => t._id !== pathwayId);
          this.toaster.success('Draft deleted.');
        } else {
          this.toaster.error((res && res.message) || 'Failed to delete draft.');
        }
        this.currentPathwayId = '';
        this.pendingAction = null;
      },
      (err: any) => {
        this.toaster.error((err && err.error && err.error.message) || 'Failed to delete draft.');
        this.pendingAction = null;
      },
    );
  }

  private publishDraft() {
    const pathwayId = this.currentPathwayId;
    this.dashboardService.publishDraft(pathwayId).subscribe(
      (res: any) => {
        if (res && res.success) {
          this.drafts = this.drafts.filter((t) => t._id !== pathwayId);
          this.toaster.success('Draft published!');
        } else {
          this.toaster.error((res && res.message) || 'Failed to publish draft.');
        }
        this.currentPathwayId = '';
        this.pendingAction = null;
      },
      (err: any) => {
        this.toaster.error((err && err.error && err.error.message) || 'Failed to publish draft.');
        this.pendingAction = null;
      },
    );
  }
}
